import React from "react";
import { Box, Button, styled } from "@mui/material";

/**
 * Learnosity stacks its own chrome in the root stacking context: item content
 * sits at z-index 100 and the menu region at 101, while term popups (1000) and
 * modal dialogs (1050) go higher still. The nav bar has to clear the item
 * content but stay under the popups and dialogs, so it lands in between.
 */
const NAV_BAR_Z_INDEX = 500;

/** Marks the bar so `AssessmentLayout` can find and measure it. */
export const NAV_BAR_ATTRIBUTE = "data-ladder-nav-bar";

const NavBarContainer = styled(Box)(({ theme }) => ({
  label: "NavBarContainer",
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  padding: "16px 0",
  backgroundColor: theme.palette.background.default,
  borderTop: `1px solid ${theme.palette.divider}`,
  zIndex: NAV_BAR_Z_INDEX,
}));

export const NavButton = styled(Button)({
  label: "NavButton",
  fontSize: "1.25em",
  padding: "0.4em 0.9em",
});

interface LadderNavBarProps {
  children?: React.ReactNode;
}

/**
 * Fixed footer for the ladder views that supply their own navigation.
 * `AssessmentLayout` measures it and shrinks the assessment area to match, so
 * the activity scrolls in the space above rather than underneath it.
 */
export const LadderNavBar = ({ children }: LadderNavBarProps) => (
  <NavBarContainer {...{ [NAV_BAR_ATTRIBUTE]: "" }}>{children}</NavBarContainer>
);
